import { baseApi } from './baseApi';

export const companyApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getCurrentCompany: builder.query({
      query: () => '/companies/current',
      providesTags: ['Company'],
    }),
    updateCurrentCompany: builder.mutation({
      query: (data) => ({
        url: '/companies/current',
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['Company'],
    }),
  }),
});

export const {
  useGetCurrentCompanyQuery,
  useUpdateCurrentCompanyMutation,
} = companyApi;
